import React, {Fragment, useRef, useState, useContext, useMemo, useEffect} from "react";
import {Editor} from '@tinymce/tinymce-react';
import {FONT_FAMILIES} from "../constants";
import AppLoader from "../../../shared/AppLoader";
import {fontsUrl} from "../../../utils/useFonts";
import {EditorContext} from "../../../utils/contexts";
import oneColor from 'onecolor';

const apiKey = "o2eq3wmxa3cdgu1xiqzoi4nt21q9o03nzlu1p9mcnemxuar5"

const allowEditing = (editor) => {
  const getBody = (event) => event.target.iframeElement.contentDocument.body
  const forEachDataTag = (body, handler) => {
    body.querySelectorAll('.data-tag').forEach(element => handler(element))
  }
  
  editor.on('BeforeExecCommand', (e) => {
    const body = getBody(e)
    forEachDataTag(body, element => {
      element.setAttribute('contenteditable', true)
    })
  });
  
  editor.on('ExecCommand', (e) => {
    const body = getBody(e)
    forEachDataTag(body, element => {
      element.setAttribute('contenteditable', false)
    })
  });
}

const addCustomButtons = function (editor, siteType) {
  editor.ui.registry.addMenuButton('mergefields', {
    text: 'Merge Fields',
    fetch: function (callback) {
      const items = [
        {
          type: 'nestedmenuitem',
          text: 'Peronal',
          getSubmenuItems: function () {
            return [
              {
                type: 'menuitem',
                text: 'Name',
                onAction: function () {
                  editor.insertContent('<span class="data-tag">{{name}}</span>');
                }
              },
              {
                type: 'menuitem',
                text: 'Email',
                onAction: function () {
                  editor.insertContent('<span class="data-tag">{{email}}</span>');
                }
              }
            ];
          }
        },
        {
          type: 'nestedmenuitem',
          text: 'Geolocation',
          getSubmenuItems: function () {
            return [
              {
                type: 'menuitem',
                text: 'Country',
                onAction: function () {
                  editor.insertContent('<span class="data-tag">{{geolocation.countryName}}</span>');
                }
              },
              {
                type: 'menuitem',
                text: 'City',
                onAction: function () {
                  editor.insertContent('{{geolocation.city}}</span>');
                }
              }
            ];
          }
        }
      ];
      if (siteType.shopifySite) {
        items.push(
          {
            type: 'nestedmenuitem',
            text: 'Shopify Cart',
            getSubmenuItems: function () {
              return [
                {
                  type: 'menuitem',
                  text: 'Product Title',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_c_pn}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Product Description',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_c_pd}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Product Price',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_c_pp}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Product Image',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_c_pi}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Items Count',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_c_cnt}}</span>'
                    );
                  },
                },
              ];
            },
          },
          {
            type: 'nestedmenuitem',
            text: 'Recommended Product',
            getSubmenuItems: function () {
              return [
                {
                  type: 'menuitem',
                  text: 'Title',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_rp_t}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Description',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_rp_d}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Price',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_rp_p}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Image',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_rp_i}}</span>'
                    );
                  },
                },
                {
                  type: 'menuitem',
                  text: 'Link',
                  onAction: function () {
                    editor.insertContent(
                      '<span class="data-tag">{{s_rp_l}}</span>'
                    );
                  },
                },
              ];
            },
          }
        )
      }
      if (siteType.bigcommerceSite) {
        items.push({
          type: 'nestedmenuitem',
          text: 'BigCommerce Cart',
          getSubmenuItems: function () {
            return [
              {
                type: 'menuitem',
                text: 'Product Title',
                onAction: function () {
                  editor.insertContent(
                    '<span class="data-tag">{{bc_c_pt}}</span>'
                  );
                },
              },
              {
                type: 'menuitem',
                text: 'Product Price',
                onAction: function () {
                  editor.insertContent(
                    '<span class="data-tag">{{bc_c_pp}}</span>'
                  );
                },
              },
              {
                type: 'menuitem',
                text: 'Product Image',
                onAction: function () {
                  editor.insertContent(
                    '<span class="data-tag">{{bc_c_pi}}</span>'
                  );
                },
              },
              {
                type: 'menuitem',
                text: 'Items Count',
                onAction: function () {
                  editor.insertContent(
                    '<span class="data-tag">{{bc_c_cnt}}</span>'
                  );
                },
              },
            ];
          }
        })
      }
      callback(items);
    }
  });
  editor.ui.registry.addMenuButton('countdown', {
    text: 'Countdown',
    fetch: function (callback) {
      const items = [
        {
          type: 'menuitem',
          text: 'Seconds',
          onAction: function () {
            editor.insertContent('<span class="data-tag">{{cd_seconds}}</span>');
          }
        },
        {
          type: 'menuitem',
          text: 'Minutes',
          onAction: function () {
            editor.insertContent('<span class="data-tag">{{cd_minutes}}</span>');
          }
        },
        {
          type: 'menuitem',
          text: 'Hours',
          onAction: function () {
            editor.insertContent('<span class="data-tag">{{cd_hours}}</span>');
          }
        },
        {
          type: 'menuitem',
          text: 'Days',
          onAction: function () {
            editor.insertContent('<span class="data-tag">{{cd_days}}</span>');
          }
        }
      ];
      callback(items);
    }
  });
}

export default function RichTextEditorPanel({ html, defaultContent, defaultFont, onUpdate, options, siteType, contentKey }) {
  const { settings, updateSettings } = useContext(EditorContext);
  const [loading, setLoading] = useState(true)
  const [content,] = useState(html)
  const editorRef = useRef(null);
  
  const fontFormats = React.useMemo(() => 
    Object.keys(FONT_FAMILIES).map((key) => `${FONT_FAMILIES[key]}=${key}`).join(';'), 
    []
  );

  const setAdvancedClass = (e) => {
    if (e.node.firstChild?.classList) {
      e.node.firstChild.classList.add('data-tag')
    }
  }

  const plugins = [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount emoticons noneditable',
    ...options?.plugins
  ]

  const initSettings = React.useMemo(() => ({
    height: 400,
    menubar: false,
    plugins: plugins,
    toolbar1: 'alignleft aligncenter alignright indent outdent lineheight countdown mergefields',
    toolbar2: `bold italic underline emoticons removeformat | forecolor fontselect fontsizeselect ${options?.toolbar}`,
    setup: (editor) => {
      editor.on('ExecCommand', (e) => {
        if (contentKey === 'link_text') {
          const update = {};
          if (e.command === 'ForeColor') {
            const hex = e.value ? oneColor(e.value).hex().replace('#', '') : null;
            if (hex) {
              update.link_color = hex;
              update.cta_hover_text_color = hex;
              update.conversion_font_color = hex;
            }
          } else if (e.command === 'Bold') {
            const isBold = editor.queryCommandState('Bold');
            update.cta_bold = isBold;
            update.cta_hover_bold = isBold;
          } else if (e.command === 'Italic') {
            const isItalic = editor.queryCommandState('Italic');
            update.cta_italic = isItalic;
            update.cta_hover_italic = isItalic;
          } else if (e.command === 'Underline') {
            const isUnderline = editor.queryCommandState('Underline');
            update.cta_underline = isUnderline;
            update.cta_hover_underline = isUnderline;
          }
          if (Object.keys(update).length > 0) {
            updateSettings(update);
          }
        }
      });

      addCustomButtons(editor, siteType);
      allowEditing(editor);
      return [editor.on('PreProcess', setAdvancedClass)]
    },
    elementpath: false,
    font_formats: fontFormats,
    branding: false,
    fontsize_formats: "8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt 40pt 44pt 48pt 60pt 72pt 96pt",
    indentation: '20px',
    font_css: fontsUrl(),
    content_style: `
      span.data-tag { color: gray; }
      ${contentKey === 'link_text' ? `
        .mce-content-body { color: inherit; }
        .mce-content-body p, .mce-content-body span, .mce-content-body b, .mce-content-body i, .mce-content-body h1, .mce-content-body h2, .mce-content-body h3, .mce-content-body h4, .mce-content-body h5, .mce-content-body h6, .mce-content-body a { 
          color: inherit; 
          font-weight: inherit; 
          font-style: inherit; 
          text-decoration: inherit; 
        }
        .mce-content-body strong { font-weight: bold; }
        .mce-content-body em { font-style: italic; }
        .mce-content-body u { text-decoration: underline; }
      ` : ''}
    `,
    default_link_target: '_blank',
    target_list: false,
    noneditable_noneditable_class: 'data-tag',
  }), [contentKey, fontFormats, options.toolbar, siteType, updateSettings, plugins]);

  const onInit = (evt, editor) => {
    setLoading(false)
    editorRef.current = editor
  }

  const onEditorChange = (value) => {
    onUpdate(value)
  }

  React.useEffect(() => {
    if (editorRef.current && contentKey === 'link_text') {
      const body = editorRef.current.getBody();
      const color = settings.link_color || settings.conversion_font_color || (settings.button_color === 'ffffff' ? '000000' : 'ffffff');
      body.style.setProperty('color', `#${color}`, 'important');
      body.style.setProperty('font-weight', settings.cta_bold ? 'bold' : 'normal', 'important');
      body.style.setProperty('font-style', settings.cta_italic ? 'italic' : 'normal', 'important');
      body.style.setProperty('text-decoration', settings.cta_underline ? 'underline' : 'none', 'important');
    }
  }, [settings.link_color, settings.cta_bold, settings.cta_italic, settings.cta_underline, settings.conversion_font_color, settings.button_color, contentKey]);

  return (
    <Fragment>
      <AppLoader visible={loading}/>
      <Editor
        scriptLoading={{ async: true }}
        onInit={onInit}
        initialValue={content}
        apiKey={apiKey}
        init={initSettings}
        onEditorChange={onEditorChange}
      />
    </Fragment>
  )
}
